import { Stack, IconButton, Box } from '@mui/material';
import { Link } from 'react-router';
import { dictionary } from '../../dictionary';
import { palette } from '../../theme';
import { contactActions } from '../shared/contactActions';

export default function Footer() {
  return (
    <Stack
      component='footer'
      sx={{
        backgroundColor: palette.primary,
        color: palette.white,
        px: { mobile: '16px', laptop: '50px' },
        py: '20px',
      }}
    >
      <Stack direction={'row'} justifyContent='space-between' alignItems={'center'} gap={2}>
        {/* Contact Info */}
        <Stack gap={'8px'} alignItems='center' direction='row'>
          {contactActions.map((action) => (
            <IconButton
              key={action.label}
              component='a'
              href={action.href}
              {...(action.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              aria-label={action.label}
              sx={{
                color: palette.white,
                '&:hover': {
                  color: palette.accent,
                },
                '& .MuiSvgIcon-root': {
                  fontSize: { mobile: '20px', laptop: '24px' },
                },
              }}
              size='small'
            >
              {action.icon}
            </IconButton>
          ))}
        </Stack>

        {/* Logo & Firm Name */}
        <Box component={Link} to='/' sx={{ maxHeight: { laptop: '31.39px', mobile: '18.83px' } }}>
          <Box
            component={'img'}
            src='/images/logo.png'
            alt={dictionary.general.firmName}
            sx={{ width: { laptop: '100px', mobile: '100px' } }}
          />
        </Box>
      </Stack>
    </Stack>
  );
}
